<template>
  <b-card v-if="data" no-body class="card-statistics">
    <b-card-header>
      <b-card-title>{{
        title ? title : $t('statistics_in_range')
      }}</b-card-title>
      <b-card-text class="font-small-2 mr-25 mb-0"> </b-card-text>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="(item, index) in data"
          :key="index"
          :class="item.customClass"
          class="col-md-offset-1"
        >
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" :variant="item.color">
                <feather-icon size="24" :icon="item.icon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>

              <b-card-text v-if="item.datetime" class="font-small-3 mb-0">
                {{ item.datetime }}
              </b-card-text>
              <b-card-text v-if="item.vehicleType" class="font-small-3 mb-0">
                {{ item.vehicleType }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col v-if="hasSlot">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" variant="light-success">
                <feather-icon size="24" icon="TrendingDownIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body style="padding-top:3px">
              <slot name="customItem"></slot>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
} from 'bootstrap-vue';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
    },
  },
  computed: {
    hasSlot() {
      return !!this.$slots['customItem'];
    },
  },
};
</script>
